import React from "react";
import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <div className="pt-24" data-testid="page-contact">
      <Contact />
    </div>
  );
}
